import { GetStaticProps } from "next";
import { NextSeo } from "next-seo";
import { ReactElement } from "react";
import { BlogArchiveContent } from "~/components/blog/BlogArchiveContent";
import { MainLayout } from "~/components/layouts/MainLayout";
import {
  getBlogArchiveLinkTags,
  getBlogArchivePageMetaTitle,
  type BlogArchivePageData,
} from "~/lib/blogArchive";
import { NextPageWithLayout } from "~/pages/_app";

type Props = BlogArchivePageData;

const BLOG_INDEX_DESCRIPTION =
  "Artykuły o bezpieczeństwie instalacji elektrycznych, gazowych i przeciwpożarowych. Porady dla właścicieli nieruchomości.";

function getBaseUrl() {
  return (process.env.NEXT_PUBLIC_BASE_URL ?? "https://inspektomat.pl").replace(
    /\/+$/,
    ""
  );
}

const BlogIndexPage: NextPageWithLayout<Props> = (props) => (
  <BlogArchiveContent {...props} />
);

BlogIndexPage.getLayout = (page: ReactElement<Props>) => (
  <MainLayout>
    <NextSeo
      title={getBlogArchivePageMetaTitle(1)}
      description={BLOG_INDEX_DESCRIPTION}
      additionalLinkTags={getBlogArchiveLinkTags(
        getBaseUrl(),
        page.props.currentPage,
        page.props.totalPages
      )}
    />
    {page}
  </MainLayout>
);

export const getStaticProps: GetStaticProps<Props> = async () => {
  const { getBlogArchivePageData } = await import("~/lib/blogArchiveData");
  const data = getBlogArchivePageData(1);

  if (!data) {
    return { notFound: true };
  }

  return { props: data };
};

export default BlogIndexPage;
